import type { DashboardMetric } from "../type";
import { SegmentsGroupMonthlyVisitsGraphWidget } from "./SegmentsGroupMonthlyVisitsGraphWidget";

export class SegmentsPageViewsGroupGraphWidget extends SegmentsGroupMonthlyVisitsGraphWidget {
    protected metric: DashboardMetric;
    protected dataSource;

    constructor() {
        super();
        this.dataSource = "PagesViews";
        this.metric = "SegmentsPageViewsGroup";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsPageViewsGroupGraph";
    }
}

SegmentsPageViewsGroupGraphWidget.register();
